import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { GetCwsPlanGoodsListService } from './api-services/get-cws-plan-goods-list.service';
import { KYMW5900Component } from './kymw5900.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';

/**
 * EC企画商品一覧表画面 モジュール設定クラス
 *
 * @export KYMW5900Module
 * @class KYMW5900Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW5900Component,
  ],
  providers: [
    GetCwsPlanGoodsListService,
  ],
})
export class KYMW5900Module {

}
